export enum AccessLevelEnum {
  NoAccess = 0,
  ReadAccess = 1,
  ReadWriteAccess = 2,
  ReadWriteAcknowledge = 3,
}

export interface AccessLevel {
  id: AccessLevelEnum;
  name: string;
  nameEn: string;
  nameFr: string;
}

export interface AccessLevelJson {
  id: AccessLevelEnum;
  name: string;
  nameEn: string;
  nameFr: string;
}

export function newAccessLevel(access?: AccessLevel): AccessLevel {
  return {
    id: AccessLevelEnum.NoAccess,
    name: '',
    nameEn: '',
    nameFr: '',
    ...access,
  };
}

export function convertAccessLevelJsonToModel(json: AccessLevelJson): AccessLevel {
  return {
    id: json.id,
    name: json.name,
    nameEn: json.nameEn,
    nameFr: json.nameFr,
  };
}
